import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import LeadDistributionsIndexPage from '../containers/LeadDistributions'
import { withAuthorization } from '../containers/Authorization'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const LeadDistributionsIndex = withAuthorization(LeadDistributionsIndexPage, ['super_admin', 'admin'])

const LeadDistributionsPage = ({ location, match }) => {
  const dispatch = useDispatch()
  const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
  const { pathname } = location

  useEffect(() => {
    if (current[0] !== 'lead_distributions') {
      dispatch(changeCurrent(['lead_distributions']))
    }
  }, [pathname])

  const path = match.url

  return (
    <Switch>
      <Route path={`${path}/`} component={LeadDistributionsIndex} exact />
    </Switch>
  )
}

LeadDistributionsPage.propTypes = {
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
}

LeadDistributionsPage.defaultProps = {}

export default LeadDistributionsPage
